/** Canonical product identity shared by every distributed surface. */
export const PRODUCT_NAME = "Kuroo CRM" as const;
export const SHORT_NAME = "Kuroo" as const;
export const BOOKING_ELEMENT_NAME = "kuroo-booking" as const;
export const SESSION_COOKIE_NAME = "kuroo_session" as const;
export const API_PREFIX = "/api/v1" as const;

export const BRAND_COLORS = {
  graphite: "#0B1020",
  violet: "#6D5EF8",
  cyan: "#22D3EE",
  ink: "#101828",
  surface: "#F7F8FC",
  border: "#D7DCEF"
} as const;

export const BRAND_TOKENS = `:root{--kuroo-graphite:${BRAND_COLORS.graphite};--kuroo-violet:${BRAND_COLORS.violet};--kuroo-cyan:${BRAND_COLORS.cyan};--kuroo-ink:${BRAND_COLORS.ink};--kuroo-surface:${BRAND_COLORS.surface};--kuroo-border:${BRAND_COLORS.border}}`;
